import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText,
  FDDisplayText,
  FDIcon,
  FDStack,
} from '@facet-wealth/design';
import AccountCard from './AccountCard';
import { TransferCompleteStatusCard } from './TransferCompleteStatusCard';

const ACHTransferCompletePage = ({
  title,
  subtitle,
  sourceAccount,
  transferInfo,
}) => {
  return (
    <FDStack direction="column" spacing={3} paddingY={2} alignItems="center">
      <FDIcon size="xl" icon="fac" />
      <FDDisplayText size="sm" value={title} align="center" color="textPrimary" />
      <FDStack direction="column" spacing={2.2} width={'100%'}>
        <AccountCard iconSrc={sourceAccount.image} {...sourceAccount} />
        <TransferCompleteStatusCard
          amount={transferInfo.amount}
          transferDate={transferInfo.startDate}
          transferSourceMaskedAccountNumber={sourceAccount.maskedAccountNumber}
          transferStatus={transferInfo.status}
        />
      </FDStack>
      <FDBodyText size="md" value={subtitle} align="start" />
    </FDStack>
  );
};


ACHTransferCompletePage.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  sourceAccount: PropTypes.object,
  transferInfo: PropTypes.object.isRequired,
};

export { ACHTransferCompletePage };
